export function trimPhone(input: string) {
  return input
    .replace(/^00/, '+')
    .replace(/^0/, '+41')
    .replace('+410', '+41')
    .replace(/[^0-9+]/g, '')
    .replace(/^[^+]+/, function (match) {
      return '+' + match;
    })
    .replace(/^\+0/, '+');
}
